<script>
    import { fade } from "svelte/transition";

    export let show = false;
</script>

<style>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .3);
        z-index: 105;
    }
</style>

{#if show}
    <div transition:fade={{ duration: 200 }} class="overlay" on:click></div>
{/if}